import React, { useState } from "react";
import { Box, Grid, Tooltip, IconButton, Badge } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
const CopyProjectNumber = ({ textToCopy, scoopOnHold, orderId, onClick }) => {
  const [hover, setHover] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = e => {
    e.stopPropagation(); // Prevent triggering row click
    navigator.clipboard.writeText(textToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  const handleClick = e => {
    if (e.ctrlKey || e.metaKey) {
      e.stopPropagation(); // Avoid triggering parent row click
      window.open(`/general/scoop/${orderId}`, "_blank");
    } else {
      onClick?.(); // Normal click
    }
  };

  return (
    <Grid
      item
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={handleClick}
      style={{
        cursor: "pointer",
        color: "blue",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {scoopOnHold ? (
        <Badge
          badgeContent={"On hold"}
          color="error"
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiBadge-badge": {
              transform: "translate(50%, -50%)",
              right: 20,
              top: -10,
            },
          }}
        >
          <Box sx={{ textDecoration: hover ? "underline" : "none" }}>{textToCopy}</Box>
        </Badge>
      ) : (
        <Box sx={{ textDecoration: hover ? "underline" : "none" }}>{textToCopy}</Box>
      )}

      {hover && (
        <Tooltip title={copied ? "Copied!" : "Copy"}>
          <IconButton size="small" onClick={handleCopy}>
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      )}
    </Grid>
  );
};
export default CopyProjectNumber;
